import * as React from 'react';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

type Props = {
    lastContactedTime: number | null | undefined;
};

export function AudienceLastContactedTime(props: Props) {
    if (!props.lastContactedTime) {
        return <div>Not yet contacted</div>;
    }

    return (
        <div className='flex align-center'>
            Last contacted&nbsp;
            <FormattedTimestamp
                format={FormattedTimestamp.formats.longMonthDayWithYear}
                datetime={props.lastContactedTime}
            />
        </div>
    );
}
